/**
 * PipedriveAPIV1Lib
 *
 * This file was automatically generated by APIMATIC v2.0 ( https://apimatic.io ).
 */

'use strict';

const IconKeyEnum = {

    /**
     * TODO: Write general description for this element
     */
    TASK: 'task',

    /**
     * TODO: Write general description for this element
     */
    EMAIL: 'email',

    /**
     * TODO: Write general description for this element
     */
    MEETING: 'meeting',

    /**
     * TODO: Write general description for this element
     */
    DEADLINE: 'deadline',

    /**
     * TODO: Write general description for this element
     */
    CALL: 'call',

    /**
     * TODO: Write general description for this element
     */
    LUNCH: 'lunch',

    /**
     * TODO: Write general description for this element
     */
    CALENDAR: 'calendar',

    /**
     * TODO: Write general description for this element
     */
    DOWNARROW: 'downarrow',

    /**
     * TODO: Write general description for this element
     */
    DOCUMENT: 'document',

    /**
     * TODO: Write general description for this element
     */
    SMARTPHONE: 'smartphone',

    /**
     * TODO: Write general description for this element
     */
    CAMERA: 'camera',

    /**
     * TODO: Write general description for this element
     */
    SCISSORS: 'scissors',

    /**
     * TODO: Write general description for this element
     */
    COGS: 'cogs',

    /**
     * TODO: Write general description for this element
     */
    BUBBLE: 'bubble',

    /**
     * TODO: Write general description for this element
     */
    UPARROW: 'uparrow',

    /**
     * TODO: Write general description for this element
     */
    CHECKBOX: 'checkbox',

    /**
     * TODO: Write general description for this element
     */
    SIGNPOST: 'signpost',

    /**
     * TODO: Write general description for this element
     */
    SHUFFLE: 'shuffle',

    /**
     * TODO: Write general description for this element
     */
    ADDRESSBOOK: 'addressbook',

    /**
     * TODO: Write general description for this element
     */
    LINEGRAPH: 'linegraph',

    /**
     * TODO: Write general description for this element
     */
    PICTURE: 'picture',

    /**
     * TODO: Write general description for this element
     */
    CAR: 'car',

    /**
     * TODO: Write general description for this element
     */
    WORLD: 'world',

    /**
     * TODO: Write general description for this element
     */
    SEARCH: 'search',

    /**
     * TODO: Write general description for this element
     */
    CLIP: 'clip',

    /**
     * TODO: Write general description for this element
     */
    SOUND: 'sound',

    /**
     * TODO: Write general description for this element
     */
    BRUSH: 'brush',

    /**
     * TODO: Write general description for this element
     */
    KEY: 'key',

    /**
     * TODO: Write general description for this element
     */
    PADLOCK: 'padlock',

    /**
     * TODO: Write general description for this element
     */
    PRICETAG: 'pricetag',

    /**
     * TODO: Write general description for this element
     */
    SUITCASE: 'suitcase',

    /**
     * TODO: Write general description for this element
     */
    FINISH: 'finish',

    /**
     * TODO: Write general description for this element
     */
    PLANE: 'plane',

    /**
     * TODO: Write general description for this element
     */
    LOOP: 'loop',

    /**
     * TODO: Write general description for this element
     */
    WIFI: 'wifi',

    /**
     * TODO: Write general description for this element
     */
    TRUCK: 'truck',

    /**
     * TODO: Write general description for this element
     */
    CART: 'cart',

    /**
     * TODO: Write general description for this element
     */
    BULB: 'bulb',

    /**
     * TODO: Write general description for this element
     */
    BELL: 'bell',

    /**
     * TODO: Write general description for this element
     */
    PRESENTATION: 'presentation',

};

module.exports = IconKeyEnum;
